import React from 'react';
import { CircularProgress } from '@mui/material';

export const Loader = () => {
  return (
    <div className={'flexCenterCenter flexGrow1 fullContent'}>
      <CircularProgress />
    </div>
  );
};
